"use client";

import { useEffect, useRef, useState, type ImgHTMLAttributes } from "react";

type Props = ImgHTMLAttributes<HTMLImageElement>;

export function ImageWithSkeleton({ className, onLoad, onError, ...rest }: Props) {
  const [loaded, setLoaded] = useState(false);
  const ref = useRef<HTMLImageElement>(null);

  // An image restored from cache is often already complete before React attaches onLoad,
  // so the event never fires — check on mount and clear the skeleton immediately.
  useEffect(() => {
    const img = ref.current;
    if (img?.complete && img.naturalWidth > 0) setLoaded(true);
  }, []);

  return (
    <>
      {!loaded && <span className="img-skeleton" aria-hidden />}
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        {...rest}
        ref={ref}
        className={className}
        style={{ opacity: loaded ? 1 : 0, transition: "opacity 300ms ease-out", ...rest.style }}
        onLoad={(e) => {
          setLoaded(true);
          onLoad?.(e);
        }}
        onError={(e) => {
          setLoaded(true);
          onError?.(e);
        }}
      />
    </>
  );
}
